module.exports = __webpack_public_path__ + "img/noavatar.bbeca107.png";